import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'

import './index.scss'
import { RealEstateDataPageComponentData } from 'types'
import Slider from 'react-slick'
import { Container } from 'react-bootstrap'

export const NextArrow = (props: any) => {
  return (
    <div
      onClick={props.onClick}
      className="next arrow-custom"
    >
      <i className="icon-arrow-stick-light"></i>
    </div>
  )
}
export const PrevArrow = (props: any) => {
  return (
    <div
      onClick={props.onClick}
      className="prev arrow-custom"
    >
      <i className="icon-arrow-stick-light"></i>
    </div>
  )
}

const settingsSlick: any = {
  dots: true,
  infinite: true,
  speed: 500,
  fade: false,
  slidesToShow: 1,
  centerPadding: 0,
  centerMode: true,
  slidesToScroll: 1,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
}

const Summary_Devs_5 = ({
  slide_items,
}: {
  slide_items: {
    photo?: string
    top_string?: string | number
    title?: string
    paragraph?: string
    link?: string
    cta?: string
    btn_image?: string
  }[]
}) => {
  const [isComponentMounted, setIsComponentMounted] = useState(false)
  useEffect(() => {
    setIsComponentMounted(true)
  }, [])

  return !isComponentMounted ? null : (
    <section className={'slider-6-component p-y-config'}>
      <Container fluid>
        <Slider {...settingsSlick}>
          {slide_items.map(({ photo, top_string, title, paragraph, link, cta, btn_image }, i) => (
            <div
              className="item-slider"
              key={i}
            >
              <img
                src={photo}
                alt="img-slider-22"
              />
              <div className="content">
                <span className="text-uppercase">{top_string}</span>
                <h2 className="my-lg-4 my-5 col-lg-6">{title}</h2>
                <p className="col-lg-6">{paragraph}</p>
                <Link
                  to={link || ''}
                  className="btn btn-white border mt-lg-5 mt-5"
                >
                  {cta}
                  {btn_image && (
                    <img
                      src={btn_image}
                      className="ms-2 d-inline-block"
                      alt=""
                    />
                  )}
                </Link>
              </div>
            </div>
          ))}
        </Slider>
      </Container>
    </section>
  )
}

export default Summary_Devs_5
